import NotificationVisualized from "./NotificationVisualized";
import GetNotification from "./GetNotification";

const Notification = {
	NotificationVisualized,
	GetNotification,
}

export default Notification;